(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/param-handler.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/param-handler.js');
"use strict";

const {
  useEffect
} = React;
const {
  useLocation
} = ReactRouterDOM;
const {
  logger
} = svs.lyckoplatsen;
const ParamHandler = _ref => {
  let {
    params = []
  } = _ref;
  const location = useLocation();
  useEffect(() => {
    try {
      params.forEach(_ref2 => {
        var _svs$utils$paramHandl;
        let {
          key,
          action
        } = _ref2;
        const value = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
          key
        })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
        if (value) {
          action(value);
          svs.utils.paramHandler.remove({
            key
          });
        }
      });
    } catch (error) {
      logger.error('Error With ParamHandlar', error);
    }
  }, [location]);
  return null;
};
Object.assign(svs.lyckoplatsen.react, {
  ParamHandler
});

 })(window);